import * as React from 'react';

import PropTypes from 'prop-types';

import { TooltipWrapper } from 'bundles/common/components/Tooltip';
import Icon from 'bundles/iconfont/Icon';

import 'css!./__styles__/CreditCardPreferenceInputRow';

class CreditCardPreferenceInputRow extends React.Component {
  static propTypes = {
    prefName: PropTypes.string.isRequired,
    isChecked: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    helpLabel: PropTypes.string.isRequired,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'prefName' does not exist on type 'Readon... Remove this comment to see the full error message
    const { prefName, isChecked, label, helpLabel } = this.props;
    const domKey = `prefinput-${prefName}`;

    return (
      <div className="rc-CreditCardPreferenceInputRow">
        <label htmlFor={domKey}>
          <input type="checkbox" name={domKey} id={domKey} value={isChecked} defaultChecked={isChecked} />
          {label}
        </label>

        <TooltipWrapper placement="right" message={helpLabel}>
          <Icon name="question-circle" className="tooltip-trigger" />
        </TooltipWrapper>
      </div>
    );
  }
}

export default CreditCardPreferenceInputRow;
